import { render, staticRenderFns } from "./Offsetting.vue?vue&type=template&id=55458051"
import script from "./Offsetting.vue?vue&type=script&lang=js"
export * from "./Offsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports